import Main from './Main'
import Lista from './components/Reboques'
import Novo from './components/NovoReboque'
import ConsultaReboque from './components/ConsultaReboque'

export default [
  {
    path: 'reboque',
    name: 'config.reboque',
    component: Main,
    redirect: { name: 'config.reboque.list' },
    children: [
      {
        path: '/',
        name: 'config.reboque.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.reboque.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.reboque.edit',
        component: Novo
      }
    ]
  },
  {
    path: '/consulta-reboque',
    name: 'config.consulta-reboque',
    component: ConsultaReboque
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/reboque/routes.js